import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';
import { Environment } from './auth.service';

export interface UserBalance {
  id: number;
  amount: number;
  onHold: number;
  credit: number;
}

export interface UserRole {
  id: number;
  name: string;
}

export interface UserById {
  id: number;
  username: string;
  email: string | null;
  phone: string | null;
  credit: number;
  isActive: boolean;
  parentId: number;
  comment: string | null;
  lastLogin: string | null;
  loginIp: string | null;
  avatarUrl: string | null;
  language: string;
  timezone: string;
  createdAt: string;
  updatedAt: string;
  Balance: UserBalance | null;
  name: string | null;
  profit: number;
  balanceOut: number;
  balanceIn: number;
  totalActiveBonus: number | null;
  role: UserRole;
  wagerBonus: number;
  dailyBonus: number;
  hourlyBonus: number;
  distributorName: string | null;
  subdistributorName: string | null;
  agentName: string | null;
  shopName: string | null;
  isWagerEnabled: boolean;
  environment: Environment;
}

export interface GetUserByIdResponse {
  user: UserById;
}

const GET_USER_BY_ID = gql`
  query GetUserById($id: Int!) {
    user(id: $id) {
      id
      username
      name
      balanceOut
      balanceIn
      profit
      totalActiveBonus
      email
      phone
      credit
      isActive
      parentId
      comment
      lastLogin
      loginIp
      avatarUrl
      language
      timezone
      createdAt
      updatedAt
      wagerBonus
      dailyBonus
      hourlyBonus
      distributorName 
      subdistributorName 
      agentName 
      shopName
      isWagerEnabled
      Balance {
        id
        amount
        credit
        onHold
      }
      role {
        id
        name
      }
      environment {
        id
        name
        host
      }
    }
  }
`;

export const getUserById = async (id: number): Promise<UserById> => {
  try {
    const response = await apolloClient.query<GetUserByIdResponse>({
      query: GET_USER_BY_ID,
      variables: { id },
      fetchPolicy: 'network-only', // Force fresh data from server
    });
    if (response.errors && response.errors.length > 0) {
      throw response;
    }
    if (!response.data || !response.data.user) {
      throw new Error('No data returned from getUserById query');
    }
    return response.data.user;
  } catch (error) {
    console.error('Error fetching user by ID:', error);
    throw error;
  }
};
